import { render, staticRenderFns } from "./CardAnaliseHistorico.vue?vue&type=template&id=006b6f26&scoped=true&lang=pug"
import script from "./CardAnaliseHistorico.vue?vue&type=script&lang=js"
export * from "./CardAnaliseHistorico.vue?vue&type=script&lang=js"
import style0 from "./CardAnaliseHistorico.vue?vue&type=style&index=0&id=006b6f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006b6f26",
  null
  
)

export default component.exports